import config from '../config/urlConfig';
import * as _ from 'lodash';

export function loadImage(url) {
  /* 
không có đường dẫn
*/
  if (_.isNil(url) || url.trim().length == 0) {
    return '';
  }

  /* 
  không có url_file và không phải chuỗi base64
  */
  if (['http://', 'https://'].every(x => url.indexOf(x) == -1) == true && url.indexOf('data:image') == -1) {
    return `${config.app.api_image}${url}`;
  }
  return url;
}
export function loadImageNew(url: string, type?: "SLIDE" | "NEWS") {
  const isHaveHttp = url.indexOf("http:") !== -1;
  const isHaveHttps = url.indexOf("https:") !== -1;
  if (isHaveHttp || isHaveHttps) {
    return url;
  } else {
    if (type === "SLIDE") {
      return `${config.app.api_image}${url}`;
    }
    return `${config.app.api_image}${url}`;
  }
}

export function isAbsoluteUrl(url: string): boolean {
  const isHaveHttp = url.indexOf("http:") !== -1;
  const isHaveHttps = url.indexOf("https:") !== -1;
  return isHaveHttp || isHaveHttps;
}